<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" >
      <el-form-item  prop="name">
        <el-input
          v-model="queryParams.name"
          :placeholder="$t('app.system.role.enterRoleName')"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item  prop="roleKey">
        <el-input
          v-model="queryParams.roleKey"
          :placeholder="$t('app.system.role.enterRoleKey')"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item prop="status">
        <el-select v-model="queryParams.status" :placeholder="$t('app.system.role.roleStatus')" clearable>
            <el-option :label="$t('app.system.role.normal')" value="1"></el-option>
            <el-option :label="$t('app.system.role.disabled')" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="roleType" v-if="adminShow">
        <el-select v-model="queryParams.roleType" :placeholder="$t('app.system.role.roleType')" clearable>
            <el-option v-for="roleType in roleTemplateList"
             :key="roleType.type"
             :label="roleType.name" 
             :value="roleType.roleType"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isSystem" v-if="adminShow">
        <el-select v-model="queryParams.isSystem" :placeholder="$t('app.system.role.systemRole')" clearable>
            <el-option :label="$t('app.common.yes')" value="1"></el-option>
            <el-option :label="$t('app.common.no')" value="0"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item prop="isDefault" v-if="adminShow">
        <el-select v-model="queryParams.isDefault" placeholder="默认角色" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('app.common.startDate')"
          :end-placeholder="$t('app.common.endDate')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="handleQuery">{{ $t('app.common.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd"
          v-hasPermi="['system:role:add']"
        >{{ $t('app.common.add') }}</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          icon="el-icon-edit"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['system:role:edit']"
        >{{ $t('app.common.edit') }}</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['system:role:del']"
        >{{ $t('app.common.delete') }}</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" border :data="roleList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column :label="$t('app.system.role.roleId')" prop="id" width="120"  align="center"/>
      <el-table-column :label="$t('app.system.role.roleName')" prop="name" :show-overflow-tooltip="true" align="center" width="150" />
      <el-table-column :label="$t('app.system.role.agentAccount')" prop="username" :show-overflow-tooltip="true" align="center" width="150" v-if="adminShow" />
      <el-table-column :label="$t('app.system.role.permissionKey')" prop="roleKey" :show-overflow-tooltip="true" align="center" width="150" />
      <el-table-column :label="$t('app.system.role.systemRole')" prop="isSystem" min-width="100" align="center" v-if="adminShow">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isSystem=='1'"  type="success">{{ $t('app.common.yes') }}</el-tag>
          <el-tag v-if="scope.row.isSystem=='0'">{{ $t('app.common.no') }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="默认角色" prop="isDefault" width="100" align="center" v-if="adminShow">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isDefault=='1'"  type="success">是</el-tag>
          <el-tag v-if="scope.row.isDefault=='0'">否</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('app.system.role.roleType')" prop="roleType" min-width="100" align="center"  v-if="adminShow">
        <template slot-scope="scope">
          {{dataRoleTye(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('app.system.role.status')" align="center" width="100" v-if="checkPermi(['system:role:updateStatus'])" >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-value="1"
            inactive-value="0"
            @change="handleStatusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('app.common.createTime')" align="center" prop="createTime" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('app.common.operation')" align="center" min-width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary" plain
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['system:role:edit']"
          >{{ $t('app.common.edit') }}</el-button>
          <el-button
            size="mini"
            type="primary" plain
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-if="idDelRole(scope.row)"
            v-hasPermi="['system:role:del']"
          >{{ $t('app.common.delete') }}</el-button>
          <el-dropdown @command="(command) => handleCommand(command, scope.row)" v-hasPermi="['system:role:edit']">
            <span class="el-dropdown-link">
              <i class="el-icon-d-arrow-right el-icon--right"></i>{{ $t('app.common.more') }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="handleDataScope" icon="el-icon-circle-check"
                v-hasPermi="['system:role:edit']">{{ $t('app.system.role.dataPermission') }}</el-dropdown-item>
              <el-dropdown-item command="handleAuthUser" icon="el-icon-user"
                v-hasPermi="['system:role:edit']">{{ $t('app.system.role.assignUser') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改角色配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.role.roleName')" prop="name">
                <el-input v-model="form.name" :placeholder="$t('app.system.role.enterRoleName')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.role.status')">
              <el-radio-group v-model="form.status">
                <el-radio label="1">{{ $t('app.system.role.normal') }}</el-radio>
                <el-radio label="0">{{ $t('app.system.role.disabled') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="adminShow">
          <el-col :span="24">
            <el-form-item :label="$t('app.system.role.roleType')" prop="roleType" >
                <el-radio-group v-model="form.roleType">
                  <el-radio
                    v-for="roleType in roleTemplateList"
                    :key="roleType.roleType"
                    :label="roleType.roleType"
                    @change.native = "handleChangeType(roleType)"
                  >{{roleType.name}}</el-radio>
                </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.roleType == '2'">
            <el-form-item :label="$t('app.system.role.roleCategory')" prop="roleSort" >
                <el-radio-group v-model="form.roleSort">
                  <el-radio label="1">{{ $t('app.system.role.proportion') }}</el-radio>
                  <el-radio label="2">{{ $t('app.system.role.floorPrice') }}</el-radio>
                  <el-radio label="3">{{ $t('app.system.role.trafficPool') }}</el-radio>
                </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
              <el-form-item :label="$t('app.system.role.menuPermission')">
                <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event, 'menu')">{{ $t('app.common.expandCollapse') }}</el-checkbox>
                <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event, 'menu')">{{ $t('app.common.selectAllNone') }}</el-checkbox>
                <el-checkbox v-model="form.menuCheckStrictly" @change="handleCheckedTreeConnect($event, 'menu')">{{ $t('app.common.parentChildLinkage') }}</el-checkbox>
                <el-input
                  :placeholder="$t('app.common.enterKeywordFilter')"
                  v-model="filterText">
                </el-input>
                <el-tree
                  class="tree-menu"
                  :data="menuOptions"
                  show-checkbox
                  ref="menu"
                  node-key="id"
                  :check-strictly="!form.menuCheckStrictly"
                  :filter-node-method="filterNode"
                  :empty-text="$t('app.common.loading')"
                  :props="defaultProps"
                ></el-tree>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('app.common.remark')">
              <el-input v-model="form.description" type="textarea" :placeholder="$t('app.common.enterContent')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">{{ $t('app.common.confirm') }}</el-button>
        <el-button @click="cancel">{{ $t('app.common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 分配角色数据权限对话框 -->
    <el-dialog :title="title" :visible.sync="openDataScope" width="500px" append-to-body :close-on-click-modal="false">
      <el-form :model="form" label-width="80px">
        <el-form-item :label="$t('app.system.role.roleName')">
          <el-input v-model="form.name" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('app.system.role.permissionKey')">
          <el-input v-model="form.roleKey" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('app.system.role.permissionScope')">
          <el-select v-model="form.dataScope" @change="dataScopeSelectChange">
            <el-option
              v-for="item in dataScopeOptions"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('app.system.role.dataPermission')" v-show="form.dataScope == 2">
          <el-checkbox v-model="deptExpand" @change="handleCheckedTreeExpand($event, 'dept')">{{ $t('app.common.expandCollapse') }}</el-checkbox>
          <el-checkbox v-model="deptNodeAll" @change="handleCheckedTreeNodeAll($event, 'dept')">{{ $t('app.common.selectAllNone') }}</el-checkbox>
          <el-checkbox v-model="form.deptCheckStrictly" @change="handleCheckedTreeConnect($event, 'dept')">{{ $t('app.common.parentChildLinkage') }}</el-checkbox>
          <el-tree
            class="tree-border"
            :data="deptOptions"
            show-checkbox
            default-expand-all
            ref="dept"
            node-key="id"
            :check-strictly="!form.deptCheckStrictly"
            :empty-text="$t('app.common.loading')"
            :props="defaultDeptProps"
          ></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDataScope">{{ $t('app.common.confirm') }}</el-button>
        <el-button @click="cancelDataScope">{{ $t('app.common.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listRole, getRole, delRole, addRole, updateRole, dataDeptScope, changeRoleStatus, roleDeptTreeSelect , listRoleTemplate } from "@/api/api";
import { moduleTreeSelect, roleModuleTreeSelect , dataScopeOptions} from "@/api/api";

export default {
  name: "role",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 角色表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      //分页信息
      pageNum: 1,
      pageSize: 10,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      menuExpand: false,
      menuNodeAll: false,
      deptExpand: true,
      deptNodeAll: false,
      // 日期范围
      dateRange: [],
      // 数据范围选项
      dataScopeOptions: [],
      // 菜单列表
      menuOptions: [],
      // 部门列表
      deptOptions: [],
      // 查询参数
      queryParams: {
        name: undefined,
        roleKey: undefined,
        status: undefined,
        roleType: undefined,
        isSystem: undefined,
        isDefault: undefined
      },
      filterText: '',
      // 表单参数
      form: {},
      defaultProps: {
        children: "children",
        label: "label"
      },
      defaultDeptProps:{
        children: "children",
        label: "name"
      },
      // 表单校验
      rules: {
        name: [
          { required: true, message: "角色名称不能为空", trigger: "blur" }
        ],
        roleKey: [
          { required: true, message: "权限字符不能为空", trigger: "blur" }
        ],
        roleType:[
          { required: true, message: "角色类型不能为空", trigger: "blur" }
        ]
      },
      roleTemplateList:[]
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  watch:{
    filterText(param){
      this.$refs.menu.filter(param);
    } 
  },
  created() {
    
    this.getList();
    this.getRoleTemplateList()
  },
  methods: {
    /** 查询角色列表 */
    getList() {
      this.loading = true;
      let params = {
        model:{
					... this.addDateRange(this.queryParams, this.dateRange),
				},
        page: this.pageNum,
        pageSize: this.pageSize,
      };
      listRole(params).then(res => {
          this.roleList = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }
      );
    },
    getRoleTemplateList(){
      let params = {
        model:{},
        page: 1,
        pageSize: 30,
      };
      listRoleTemplate(params).then(res => {
          this.roleTemplateList = res.data.data.records;
        }
      );
    },
    dataRoleTye(row){
      let item = this.roleTemplateList.find(a=>a.roleType == row.roleType)
      if(item && item.roleType == '2' && row.isSystem == '1'){
          if(row.roleSort == '1'){
              return item.name + '-比例'
          }
          if(row.roleSort == '2'){
              return item.name + '-底价'
          }
          if(row.roleSort == '3'){
              return item.name + '-流量池'
          }
          return item.name
      }
      return item && item.name
    },
    /** 查询菜单树结构 */
    getModuleTreeselect() {
      let language = localStorage.getItem('app_language') || 'zh'
      moduleTreeSelect({language}).then(res => {
        this.menuOptions = res.data.data;
      });
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys();
      // 半选中的菜单节点
      let halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    // 所有部门节点数据
    getDeptAllCheckedKeys() {
      // 目前被选中的部门节点
      let checkedKeys = this.$refs.dept.getCheckedKeys();
      // 半选中的部门节点
      let halfCheckedKeys = this.$refs.dept.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    /** 根据角色ID查询菜单树结构 */
    getRoleModuleTreeSelect(roleId) {
      let language = localStorage.getItem('app_language') || 'zh'
      return roleModuleTreeSelect({roleId : roleId,language:language}).then(res => {
        this.menuOptions = res.data.data.modules;
        return res;
      });
    },
    /** 根据角色ID查询部门树结构 */
    getDeptTree(roleId) {
      return roleDeptTreeSelect({roleId : roleId}).then(res => {
        this.deptOptions = res.data.data.depts;
        return res;
      });
    },
    // 角色状态修改
    handleStatusChange(row) {
      let text = row.status === "1" ? "启用" : "停用";
      this.$modal.confirm('确认要"' + text + '""' + row.name + '"角色吗？').then(function() {
        let params = {
          id : row.id,
          status : row.status
        }
        return changeRoleStatus(params);
      }).then(() => {
        this.$modal.msgSuccess(text + "成功");
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 取消按钮（数据权限）
    cancelDataScope() {
      this.openDataScope = false;
      this.reset();
    },
    // 表单重置
    reset() {
      if (this.$refs.menu != undefined) {
        this.$refs.menu.setCheckedKeys([]);
      }
      this.menuExpand = false,
      this.menuNodeAll = false,
      this.deptExpand = true,
      this.deptNodeAll = false,
      this.form = {
        id: undefined,
        name: undefined,
        roleKey: undefined,
        status: "1",
        roleSort:undefined,
        roleType:undefined,
        menuIds: [],
        deptIds: [],
        menuCheckStrictly: true,
        deptCheckStrictly: true,
        remark: undefined
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!=1
      this.multiple = !selection.length
    },
    // 更多操作触发
    handleCommand(command, row) {
      switch (command) {
        case "handleDataScope":
          this.handleDataScope(row);
          break;
        case "handleAuthUser":
          this.handleAuthUser(row);
          break;
        default:
          break;
      }
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      if (type == 'menu') {
        let treeList = this.menuOptions;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
        }
      } else if (type == 'dept') {
        let treeList = this.deptOptions;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.dept.store.nodesMap[treeList[i].id].expanded = value;
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      if (type == 'menu') {
        this.$refs.menu.setCheckedNodes(value ? this.menuOptions: []);
      } else if (type == 'dept') {
        this.$refs.dept.setCheckedNodes(value ? this.deptOptions: []);
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value, type) {
      if (type == 'menu') {
        this.form.menuCheckStrictly = value ? true: false;
      } else if (type == 'dept') {
        this.form.deptCheckStrictly = value ? true: false;
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.getModuleTreeselect();
      this.open = true;
      this.title = "添加角色";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const roleId = row.id || this.ids[0]
      const roleMenu = this.getRoleModuleTreeSelect(roleId);
      getRole({roleId : roleId}).then(res => {
        this.form = res.data.data;
        this.open = true;
        this.$nextTick(() => {
          roleMenu.then(res => {
            let checkedKeys = res.data.data.checkedKeys
            checkedKeys.forEach((v) => {
                this.$nextTick(()=>{
                    this.$refs.menu.setChecked(v, true ,false);
                })
            })
          });
        });
        this.title = "修改角色";
      });
    },
    /** 选择角色权限范围触发 */
    dataScopeSelectChange(value) {
      if(value !== '2') {
        this.$refs.dept.setCheckedKeys([]);
      }
    },
    /** 分配数据权限操作 */
    handleDataScope(row) {
      this.reset();
      const deptTreeSelect = this.getDeptTree(row.id);
      this.handleDataScopeOptions(row.id);
      getRole({roleId : row.id}).then(res => {
        this.form = res.data.data;
        this.openDataScope = true;
        this.$nextTick(() => {
          deptTreeSelect.then(res => {
            this.$refs.dept.setCheckedKeys(res.data.data.checkedKeys);
          });
        });
        this.title = "分配数据权限";
      });
    },
    /** 分配用户操作 */
    handleAuthUser: function(row) {
      const roleId = row.id;
      this.$router.push("/system/roleAuth/user/" + roleId);
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            this.form.moduleIds = this.getMenuAllCheckedKeys();
            updateRole(this.form).then(res => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            this.form.moduleIds = this.getMenuAllCheckedKeys();
            addRole(this.form).then(res => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 提交按钮（数据权限） */
    submitDataScope: function() {
      if (this.form.id != undefined) {
        this.form.deptIds = this.getDeptAllCheckedKeys();
        dataDeptScope(this.form).then(response => {
          this.$modal.msgSuccess("修改成功");
          this.openDataScope = false;
          this.getList();
        });
      }
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const roleIds = row.id?[row.id]:undefined || this.ids;
      this.$modal.confirm('是否确认删除角色编号为"' + roleIds + '"的数据项？').then(function() {
        return delRole(JSON.stringify(roleIds));
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    //数据权限选项查询
    handleDataScopeOptions(roleId){
      dataScopeOptions({roleId : roleId}).then(res=>{
        this.dataScopeOptions = res.data.data;
      })
    },
    idDelRole(row){
      if(this.adminShow && row.isSystem == '1'){
          return false;
      }
      if(!this.adminShow && row.isDefault =='1'){
          return false;
      }
      return true;
    },
    handleChangeType(item){
      let menuIds = item.menuIds
      this.$refs.menu.setCheckedKeys([]);
      this.$refs.menu.setCheckedKeys(menuIds);
    }
  }
};
</script>
<style scoped lang="less">
.tree-menu{
    height: calc(100vh - 540px);
    z-index: 1024;
    overflow: auto;
  }
</style>